// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsScimScimInfoResult = objectOf({
  app_groups: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
  bridge: anyOf(
    objectOf({
      ag_id: string,
      ipc_id: string,
      ip_wl: string,
      scim_url: string,
      idp: number,
      saml_url: anyOf(string, nullOrUndefined),
      entity_id: anyOf(string, nullOrUndefined),
    }),
    nullOrUndefined
  ),
});
